export enum EnumPublicationStatus {
  DRAFT = 0,
  PUBLISHED = 1,
}